<div class="rt-card layout-card" [class.active]="isActive()">
  <rt-icon [name]="icon()" margin-top-small-xx />
  <span>{{ text() }}</span>
</div>
